import { PageHero, Container, Overline } from "../components/Section";
import { Download, FileText, BookOpen, Heart } from "lucide-react";

const RESOURCES = [
  { icon: BookOpen, title: "Daily Devotional", body: "Quiet-time guides released weekly to help you stay rooted in Scripture." },
  { icon: FileText, title: "Bible Reading Plans", body: "1-year and 90-day plans to journey through Scripture together." },
  { icon: Heart, title: "Prayer Requests", body: "Submit a prayer request — our intercessory team prays daily." },
  { icon: Download, title: "Giving Statements", body: "Download year-end giving statements for tax purposes." },
  { icon: FileText, title: "Sermon Notes Archive", body: "Outlines and reflection questions from recent sermons." },
  { icon: BookOpen, title: "Recommended Reading", body: "Curated books to deepen your walk with Christ." },
];

export default function MemberResources() {
  return (
    <div data-testid="member-resources-page">
      <PageHero
        overline="Member Resources"
        title={<>Equipped to <em className="text-gold-light italic font-light">grow</em>.</>}
        kicker="Devotionals, plans, forms, and tools — everything our members need in one place."
      />

      <Container className="pb-32">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5">
          {RESOURCES.map((r) => (
            <div key={r.title} className="bg-wine-950 hover:bg-wine-900 transition-colors p-10 group cursor-pointer">
              <r.icon className="h-6 w-6 text-gold mb-5 stroke-[1.5]" />
              <h3 className="font-serif text-xl font-bold mb-3 group-hover:text-gold-light transition-colors">{r.title}</h3>
              <p className="text-white/60 text-sm leading-relaxed">{r.body}</p>
            </div>
          ))}
        </div>
      </Container>
    </div>
  );
}
